import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useContext, useMemo, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { ModalManagementStore } from '../../providers/modal-manager';
import GenericList, { GenericListItem } from '../GenericList';
import Link from '../Link';

const FingerTipsLinks: any = ({ data, className }: any) => {
  const { openModal } = useContext(ModalManagementStore);
  const [isShown, setIsShown] = useState(false);
  const handleIsShown = () => {
    setIsShown((prev) => !prev);
  };

  const displayedLinks = useMemo(() => {
    return isShown ? data : data.slice(0, 5);
  }, [isShown, data]);

  return (
    <Row className={`m-0 p-0 d-flex justify-content-between ${className}`}>
      <Row className={'m-0 p-0'}>
        <Col
          className={
            'p-0 d-flex justify-content-between align-items-center mb-10'
          }
        >
          <h4 className={'text-sm-20-lg-32 m-0 lh-xs'}>&nbsp;</h4>
        </Col>
      </Row>
      <Container className="m-0 p-10 border border-info rounded-1">
        <GenericList>
          {displayedLinks.map((link: any, index: number) => {
            let href = link['target'] ? link['link'] : `#${link['link']}`;
            if (link['modal']) {
              href = '';
            }

            return (
              <GenericListItem key={index}>
                <Link
                  rightIcon={
                    link['target'] === '_blank'
                      ? light('arrow-up-right-from-square')
                      : light('chevron-right')
                  }
                  isAlignAtEnd
                  isBlue
                  target={link['target']}
                  href={href}
                  className={'py-0'}
                  onClick={() => {
                    if (link['modal']) openModal(link['link']);
                  }}
                >
                  {link['label']}
                </Link>
              </GenericListItem>
            );
          })}

          {data.length > 5 && (
            <Container className={'col-12 text-end px-0 mt-10'}>
              <Button onClick={handleIsShown} size={'sm'}>
                Show {!isShown ? 'more' : 'less'}
              </Button>
            </Container>
          )}
        </GenericList>
      </Container>
    </Row>
  );
};

export default FingerTipsLinks;
